import { createTheme } from "@mui/material/styles";
import { green } from "@mui/material/colors";
import darkScrollbar from "@mui/material/darkScrollbar";
import { csCZ } from '@mui/material/locale';

const theme = (dark: boolean) =>
  createTheme(
    {
      components: {
        MuiCssBaseline: {
          styleOverrides: {
            body: {
              ...(dark && darkScrollbar()),
            },
          },
        },
        MuiPaper: {
          styleOverrides: {
            rounded: {
              borderRadius: "16px",
              boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.1)",
            },
          },
        },
      },
      palette: {
        mode: dark ? "dark" : "light",
        primary: {
          main: "#b9885e",
          dark: "#523c29",
        },
        secondary: {
          main: green[500],
        },
      },
    },
    csCZ
  );

export default theme;
